import React, { useMemo, useState } from "react";
import { Box, Typography, Tabs, Tab, Paper, Stack, Chip, useTheme, useMediaQuery } from "@mui/material";

import SettingsTopCards from "../components/settings/SettingsTopCards";

import OrganizationTab from "../components/settings/tabs/OrganizationTab";
import UsersTab from "../components/settings/tabs/UsersTab";
import TeachersTab from "../components/settings/tabs/TeachersTab";
import PipelineTab from "../components/settings/tabs/PipelineTab";
import TemplatesTab from "../components/settings/tabs/TemplatesTab";
import AutomationsTab from "../components/settings/tabs/AutomationsTab";
import IntegrationsTab from "../components/settings/tabs/IntegrationsTab";
import GoalsTab from "../components/settings/tabs/GoalsTab";
import SecurityTab from "../components/settings/tabs/SecurityTab";

function TabPanel({ value, index, children }) {
  if (value !== index) return null;
  return <Box sx={{ mt: 2 }}>{children}</Box>;
}

export default function SettingsPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [tab, setTab] = useState(0);

  const tabs = useMemo(
    () => [
      { label: "Organização", key: "org" },
      { label: "Usuários", key: "users" },
      { label: "Professores", key: "teachers" },
      { label: "Funil SDR", key: "pipeline" },
      { label: "Templates", key: "templates" },
      { label: "Automações", key: "automations" },
      { label: "Integrações", key: "integrations" },
      { label: "Metas", key: "goals" },
      { label: "Segurança", key: "security" },
    ],
    []
  );

  return (
    <Box p={2}>
      {/* Header */}
      <Stack direction="row" justifyContent="space-between" alignItems="flex-end" sx={{ mb: 2 }}>
        <Box>
          <Typography
            variant="h4"
            sx={{ fontWeight: 900, color: "var(--cise-blue)", letterSpacing: -0.5 }}
          >
            Configurações
          </Typography>
          <Typography sx={{ color: "var(--cise-text-muted)" }}>
            Painel de controle da operação SDR — Cultura Inglesa de Sergipe
          </Typography>
        </Box>

        <Chip
          label="CISE • SDR"
          sx={{
            fontWeight: 900,
            border: "1px solid var(--border)",
            bgcolor: "var(--branco)",
          }}
        />
      </Stack>

      {/* Cards topo */}
      <SettingsTopCards />

      {/* Tabs */}
      <Paper
        elevation={0}
        sx={{
          mt: 2,
          borderRadius: 2,
          border: "1px solid var(--border)",
          bgcolor: "var(--branco)",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            px: 1,
            bgcolor: "var(--bg)",
            borderBottom: "1px solid var(--border)",
          }}
        >
          <Tabs
            value={tab}
            onChange={(_, v) => setTab(v)}
            variant={isMobile ? "scrollable" : "standard"}
            scrollButtons={isMobile ? "auto" : false}
            allowScrollButtonsMobile
            sx={{
              "& .MuiTab-root": { textTransform: "none", fontWeight: 900, minHeight: 52 },
              "& .MuiTabs-indicator": { backgroundColor: "var(--cise-blue)" },
            }}
          >
            {tabs.map((t) => (
              <Tab key={t.key} label={t.label} />
            ))}
          </Tabs>
        </Box>

        <Box sx={{ p: 2 }}>
          <TabPanel value={tab} index={0}><OrganizationTab /></TabPanel>
          <TabPanel value={tab} index={1}><UsersTab /></TabPanel>
          <TabPanel value={tab} index={1}><PipelineTab /></TabPanel>
          <TabPanel value={tab} index={2}><TeachersTab /></TabPanel>
          <TabPanel value={tab} index={3}><TemplatesTab /></TabPanel>
          <TabPanel value={tab} index={4}><AutomationsTab /></TabPanel>
          <TabPanel value={tab} index={5}><IntegrationsTab /></TabPanel>
          <TabPanel value={tab} index={6}><GoalsTab /></TabPanel>
          <TabPanel value={tab} index={7}><SecurityTab /></TabPanel>
        </Box>
      </Paper>
    </Box>
  );
}
